<template>
  <shared-provide-variation :variation="variation" :fromModule="fromModule" :toModule="toModule" @change="emitToParent">
    <div v-for="isRequired in [true, false]" v-show="isRequired || (!isRequired && showOptionalAttributes)">
      <div class="divider" v-if="variation.leroyAttributes.some(attr => attr.required === isRequired)">
        <span>Atributos {{ isRequired ? 'obrigatórios' : 'opcionais' }}</span>
      </div>

      <div class="l-row">
        <form-group :label="$t(`crossDocking.label`)" :columns="3" :error="getError('crossDocking', variation.sku)" v-if="!isRequired">
          <input class="form-input" type="number" v-model="variation.crossDocking" :disabled="disabledInputs()">
        </form-group>

        <form-group :required="attribute.required" v-for="attribute in variation.leroyAttributes.filter(attr => attr.required === isRequired)" :key="attribute.code" :label="attribute.label" :columns="3" :error="getError(attribute.code, variation.sku)">
          <select v-model="attribute.value" class="form-select" :disabled="disabledInputs()" v-if="attribute.type === 'LIST' || attribute.code === 'seal'">
            <option :value="undefined">{{ $t('choose.label') }}</option>
            <option v-for="option in attribute.options" :value="option.code" v-if="attribute.code !== 'seal'">{{ option.label }}</option>
            <option v-for="(image, index) in variation.images" :value="image" v-if="attribute.code === 'seal'">Imagem: {{ index + 1 }}</option>
          </select>
          <input class="form-input" type="text" v-mask="'###'" v-model="attribute.value" :disabled="disabledInputs()" min="0" v-else-if="attribute.type === 'INTEGER'">
          <input class="form-input" type="text" v-mask="'###.##'" v-model="attribute.value" :disabled="disabledInputs()" min="0" v-else-if="attribute.type === 'DECIMAL'">
          <input class="form-input" type="text" v-model="attribute.value" :disabled="disabledInputs()" v-else>
          <small class="form-help" v-if="attribute.code === 'seal'">Você deve escolher o número da imagem correspondente ao selo do inmetro deste produto.</small>
        </form-group>

        <div class="l-col-12 toggle-more" v-if="isRequired">
          <span @click="() => showOptionalAttributes = !showOptionalAttributes" class="btn--sm btn--info">
            {{ !showOptionalAttributes ? 'Exibir atributos opcionais' : 'Esconder atributos opcionais' }}
          </span>
        </div>
      </div>
    </div>
  </shared-provide-variation>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      showOptionalAttributes: false
    }),
    props: {
      variation: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    methods: {
      disabledInputs () {
        return this.variation.status === 'sent' || this.variation.status === 'error'
      },
      emitToParent (value) {
        this.$emit('change', value)
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    components: {
      SharedProvideVariation,
      FormGroup
    }
  }
</script>

<style lang="sass" scoped>
  .toggle-more
    cursor: pointer
    margin-bottom: 16px
</style>



// WEBPACK FOOTER //
// Variation.vue?2d24c3b9